<vs-dialog [config]="{ dialogContainerClass: 'w-[480px]', disableBackdropDismiss: uploading }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      showDivider: true,
      icon: attaching ? 'attachment-02' : 'check-circle',
      iconTheme: 'primary',
      title: title,
      hideCloseButton: uploading
    }"
  ></vs-dialog-header>

  <div class="flex flex-col gap-4 p-4">
    <vs-form-field *ngIf="!attaching" [config]="{ label: config.completeHoldDialog.noteLabel }" data-testid="hold-note">
      <textarea vsInput [formControl]="note" [placeholder]="config.completeHoldDialog.notePlaceholder"></textarea>
    </vs-form-field>

    <vs-form-field
      *ngIf="canViewFiles"
      [config]="{ label: config.completeHoldDialog.filesLabel }"
      data-testid="hold-files"
    >
      <div *ngIf="linked.length" class="flex flex-wrap items-center gap-1.5 mb-2" data-testid="hold-already-attached">
        <span class="text-xs text-gray-500">{{ config.completeHoldDialog.alreadyAttached }}</span>
        <span
          *ngFor="let file of linked"
          class="inline-flex items-center gap-1.5 max-w-full min-w-0 rounded-full border border-gray-200 py-0.5 pl-0.5 pr-2.5 text-xs text-gray-700"
          [title]="file.title"
          data-testid="hold-attached-file"
        >
          <ws-file-thumb [file]="filesById.get(file.storageItemId)" [size]="20" [round]="true"></ws-file-thumb>
          <span class="truncate">{{ file.title }}</span>
          <span *ngIf="file.removed" class="shrink-0 text-gray-400">{{ config.holds.removedFile }}</span>
        </span>
      </div>

      <p *ngIf="(files$ | async)?.length === 0; else picker" class="text-sm text-gray-500" data-testid="hold-no-files">
        {{ linked.length ? config.completeHoldDialog.noOtherFiles : config.completeHoldDialog.noFiles }}
      </p>

      <ng-template #picker>
        <vs-select
          vsInput
          [formControl]="documentIds"
          [config]="{ multiple: true, placeholder: config.completeHoldDialog.filesPlaceholder }"
        >
          <!-- Plain markup: the select copies each option's HTML into its box and list -->
          <li *ngFor="let file of files$ | async" vs-select-option [value]="file.id">
            <span class="flex items-center gap-2 min-w-0">
              <img
                *ngIf="thumbFor(file) as url; else fileTile"
                class="w-7 h-7 rounded object-cover shrink-0"
                [src]="url"
                alt=""
              />
              <ng-template #fileTile>
                <span
                  class="flex items-center justify-center w-7 h-7 rounded bg-gray-100 text-[9px] font-bold text-gray-500 shrink-0"
                >
                  {{ typeLabel(file) ?? '' }}
                </span>
              </ng-template>
              <span class="truncate" data-testid="hold-file-name">{{ file.title || file.originalFilename }}</span>
            </span>
          </li>
        </vs-select>
      </ng-template>

      <span *ngIf="overLimit" class="text-xs text-danger" data-testid="hold-too-many"> {{ maxFilesText }} </span>

      <div *ngIf="canUploadFiles" class="flex flex-col items-start gap-1 mt-2">
        <input
          #fileInput
          type="file"
          class="hidden"
          multiple
          [accept]="accept"
          (change)="upload(fileInput)"
          data-testid="hold-upload-input"
        />
        <!-- Disabled until the file list loads, so the list can't overwrite a fresh upload. -->
        <button
          vs-button
          appearance="outline"
          size="sm"
          [disabled]="uploading || (files$ | async) === null"
          (click)="fileInput.click()"
          data-testid="hold-upload"
        >
          <vs-icon name="upload-01"></vs-icon>
          {{ uploading ? config.completeHoldDialog.uploading : config.completeHoldDialog.upload }}
        </button>
        <span class="text-xs text-gray-500">{{ config.completeHoldDialog.uploadHint }}</span>
      </div>
    </vs-form-field>
  </div>

  <div class="flex justify-end gap-2 px-4 pb-4">
    <button vs-button appearance="outline" [disabled]="uploading" (click)="close()" data-testid="hold-close">
      {{ closeLabel }}
    </button>
    <button vs-button theme="primary" [disabled]="!canConfirm" (click)="confirm()" data-testid="hold-confirm">
      {{ saveLabel }}
    </button>
  </div>
</vs-dialog>
